import { Component } from 'react';
import withRouter from '../../lib/withRouter';
import Authentication from './../../session';
import { RadioButton } from 'primereact/radiobutton';
import { CancelRed, GreenCheck } from '../../svgIcons';
import LoadingComponent from '../../loadingComponent';
import Service from '../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';
import { Toast } from 'primereact/toast';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';
import { BasicLazyParams } from '../../../utile';
import { debounce } from 'lodash';
import ClassetInputText from '../../../classetComponents/classetInputText';
import { Dialog } from 'primereact/dialog';
import '../styles.scss';
import ClassetTextArea from '../../../classetComponents/classetTextArea';
import BranchToSectionApprovalHierarchy from '../../BaseDropdownComponents/BranchToSectionApprovalHierarchy';

import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';

const searchTypeOptions = [
    { label: 'Student Name', value: 'studentName' },
    { label: 'Enrollment Number', value: 'enrollmentNumber' }
];

class FeeRefundApproval extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lazyParams: BasicLazyParams,
            searchType: 1,
            searchInput: '',
            studentInfo: [],
            raisedFeeRefundData: {},
            studentId: null,
            searchLevel: 1,
            searchType: searchTypeOptions[0].value,
            viewRefundDetails: false,
            remarks: '',
            // filters: {

            //     'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            //     'name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            //     // 'country.name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            //     // 'representative': { value: null, matchMode: FilterMatchMode.IN },
            //     // 'date': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
            //     // 'balance': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            //     // 'status': { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            //     // 'activity': { value: null, matchMode: FilterMatchMode.BETWEEN }
            // },
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'firstName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'lastName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'enrollmentId': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'contactPersonName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'parentContactNo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'totalFee': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                'refundRaisedAmt': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }
            },
            globalFilterValue: '',
        };
        this.debouncedApiCall = debounce(this.getStudentsInfo, 500);
        this.service = new Service();
    }

    // setDropdownValues = (dropdownsData) => {
    //     this.setState(
    //         {
    //             dropdownsData,
    //             studentId: null
    //         },
    //         () => {
    //             this.getStudentsInfo();
    //         }
    //     );
    // };

    setDropdownValues = (dropdownsData, payload) => {
        this.setState(
            {
                dropdownsData,
                studentIds: payload?.studentIds || [],
                enrollmentIds: payload?.enrollmentIds || [],
            },
            () => {

                 // Check if branchIds is empty array and prevent API call
                if (!this.state?.dropdownsData?.branchIds ||
                    (Array.isArray(this.state?.dropdownsData?.branchIds) && this.state?.dropdownsData?.branchIds.length === 0)) {
                    console.log('No branches selected, skipping API call');
                    this.setState({
                        isLoading: false,
                        studentInfo: [],
                        studentstotalRecords: 0
                    });
                    return;
                }
                
                this.getStudentsInfo();
            }
        );
    };



    onHandleViewFeeConcessions = (data) => {
        this.setState({
            viewRefundDetails: true,
            raisedFeeRefundData: data
        });
    };
    onHandleRefundClose = () => {
        this.setState(
            {
                viewRefundDetails: false,
                raisedFeeRefundData: {},
                remarks: ''
            },
            () => this.getStudentsInfo()
        );
    };
    onShowDetailedReport = () => {
        this.setState({
            isLoading: true
        });
    };
    onHandleApprovedRefunds = () => {
        this.setState({ isLoading: true });
        const { raisedFeeRefundData, remarks } = this.state;
        let isAllRefundChecked = true;

        if (raisedFeeRefundData?.refundFeeTypesData?.length) {
            for (const el of raisedFeeRefundData.refundFeeTypesData.filter(e => e?.isClosed == false || e?.isClosed == undefined)) {
                if (!el.hasOwnProperty('isRefundApproved')) {
                    isAllRefundChecked = false;
                    break;
                }
            }
        }
        if (!isAllRefundChecked) {
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Please approve/reject all the fee types', detail: 'Please approve/reject all the fee types', life: 3000 });
            return;
        }
        let payload = {
            _id: raisedFeeRefundData?._id,
            user_id: raisedFeeRefundData?.user_id,
            isClosed: true,
            refundFeeTypesData: raisedFeeRefundData?.refundFeeTypesData,
            remarks: remarks,
            academicYear: raisedFeeRefundData?.academicYear,
            branchId: raisedFeeRefundData?.branchId,
            handledBy: this.state.raisedFeeRefundData?.handledBy || [],
            levelAndBranchDetails: this.state.dropdownsData?.heirarchy?.adminLevels?.filter((al) => al._id == this.state.raisedFeeRefundData?.branchId),
            // Payment details from fee refund
            paymentType: raisedFeeRefundData?.paymentType,
            // Online payment fields
            bankAccountHolderName: raisedFeeRefundData?.bankAccountHolderName,
            accountNumber: raisedFeeRefundData?.accountNumber,
            ifscCode: raisedFeeRefundData?.ifscCode,
            bankNameAndBranch: raisedFeeRefundData?.bankNameAndBranch,
            // QR Code payment field
            upiId: raisedFeeRefundData?.upiId,
            // Cheque payment fields
            chequeIssuedTo: raisedFeeRefundData?.chequeIssuedTo,
            chequeNo: raisedFeeRefundData?.chequeNo,
            chequeDate: raisedFeeRefundData?.chequeDate,
            bankName: raisedFeeRefundData?.bankName,
            bankBranchName: raisedFeeRefundData?.bankBranchName
        };

        let url = `${baseUrlAdmin}/refund-approval/update-refund-approvals`;
        this.setState({ isLoading: true });
        this.service
            .put(url, payload, true)
            .then((res) => {
                if (res?.status && res?.res?.status) {
                    this.setState(
                        {
                            viewRefundDetails: false,
                            raisedFeeRefundData: {},
                            remarks: '',
                            isLoading: false
                        },
                        this.toast.show({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'Refund request processed successfully',
                            life: 3000
                        }),
                        this.getStudentsInfo()
                    );
                } else {
                    this.setState({ isLoading: false });
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((error) => {
                this.setState({ isLoading: false });
            });
    };

    handleSetSearchValue = (value) => {
        this.setState(
            {
                searchValue: value,
                dropdownsData: { ...this.state.dropdownsData, boardId: '', branchId: '', classId: '', sectionId: '' }
            },
            () => {
                if (!this.state.searchValue == '') {
                    this.debouncedApiCall();
                }
            }
        );
    };
    handleSearchLevel = (value) => {
        this.setState({ searchLevel: value, studentId: '', searchValue: '', studentsData: [] });
    };

    onStudentChange = (e) => {
        this.setState({ studentId: e.value }, () => {
            this.getStudentsInfo();
        });
    };

    handleTermWisePercentageValue = (e, rowData) => {
        let concessionAmt = Number(e.target.value);
        if (rowData.dueAmount > 0) {
            if (rowData?.dueAmount >= concessionAmt) {
                const updatedData = this.state.raiseData.map((item) => {
                    if (item._id === rowData._id) {
                        return { ...item, currentConAmt: concessionAmt };
                    }
                    return item;
                });
                this.setState({ raiseData: updatedData });
            }
        }
    };

    handleSetSearchTypeValue = (value) => {
        this.setState({ searchType: value }, () => {
            if (this.state.searchType == 'studentName') {
                this.setState({ isUserNameSearch: true });
            } else {
                this.setState({ isUserEnrollSearch: true });
            }
        });
    };

    getStudentsInfo = () => {
        let { lazyParams, globalSearch, filterData } = this.state;
        this.setState({ isLoading: true, studentInfo: [] });
        const url = `${baseUrlAdmin}/refund-approval/get-refund-approvals?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch}`;

        let academicYear = localStorage.getItem('userAcademicYear');
        let username = this.state.searchType === 'studentName' ? this.state?.searchValue : '';
        let enrollmentNo = this.state.searchType === 'enrollmentNumber' ? this.state?.searchValue : '';

        let payload = {
            branchId: this.state?.dropdownsData?.branchIds,
            boardId: this.state?.dropdownsData?.boardIds,
            gradeId: this.state?.dropdownsData?.classIds,
            sectionId: this.state?.dropdownsData?.sectionId,
            // studentId: this.state?.studentId,
            studentId: this.state?.dropdownsData?.studentIds,

            academicYear: academicYear,
            username: this.state.searchLevel == 2 ? username : '',
            enrollmentNo: enrollmentNo,
            assignedHeirarchy: this.state.dropdownsData?.heirarchy
        };

        this.service
            .post(url, payload, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    if (res.res?.data && res.res?.data?.length) {
                        this.setState({
                            isLoading: false,
                            studentInfo: res?.res?.data,
                            totalRecords: res?.res?.totalRecords
                        });
                    } else if (res.res?.data?.length == 0) {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'error', summary: 'No records found.', detail: '', life: 3000 });
                    } else {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                    }
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false
                });
                console.log(e);
            });
    };
    onHandleFeeRefundApprove = (rowData, status) => {
        this.setState((prevState) => {
            const updatedItems = prevState.raisedFeeRefundData?.refundFeeTypesData?.map((item) => {
                if (item._id === rowData?._id) {
                    return { ...item, isRefundApproved: status };
                }
                return item;
            });
            let feeInfo = prevState.raisedFeeRefundData;
            return { raisedFeeRefundData: { ...feeInfo, refundFeeTypesData: updatedItems } };
        });
    };

    renderHeader() {
        return (
            <div className="flex justify-content-between align-items-center">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={this.state.globalFilterValue} onChange={this.onGlobalFilterChange} placeholder="Name / Id / Phone No" />
                </span>
                {/* <h5 className="m-0">Customers</h5> */}
            </div>
        )
    }
    onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let filters = { ...this.state.filters };
        filters['global'].value = value;
        this.setState({ filters, globalFilterValue: value });
    };

    render() {
        const header = this.renderHeader();
        return (


            <div className="ma-main">
                <div className=" datatable-crud-demo ma-m30 mx-2 mb-5">
                    <div className="flex">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton inputId="ingredient1" onChange={(e) => this.handleSearchLevel(1)} checked={this.state.searchLevel === 1} />
                        </div>

                        <div>
                           <BranchToSectionApprovalHierarchy selectedValue={this.state.searchLevel} setValues={this.setDropdownValues} approvalType={'feeRefund'} />
                        </div>
                    </div>
                    {/* <div style={{ marginLeft: '100px' }} className="flex justify-content-start align-items-center">
                        <span className="">OR</span>
                    </div> */}
                    {/* <div className="flex mt-4">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton inputId="ingredient2" onChange={(e) => this.handleSearchLevel(2)} checked={this.state.searchLevel === 2} />
                        </div>

                        <div className="field ml-4">
                            <ClassetStudentSearchFilter
                                selectedValue={this.state.searchLevel}
                                setValues={this.setDropdownValues}
                            />
                        </div>
                    </div> */}

                    {/* <div className="col-12 ml-5">
                        <label className="label">
                            Student<span className="ma-required">*</span>
                        </label>
                        <div className="mt-2">
                            <ClassetDropdown
                                icon={<MailIcon />}
                                id="student"
                                className=""
                                height="48px"
                                width="327px"
                                options={this.state?.students}
                                value={this.state.studentId}
                                disabled={this.state?.searchLevel === 2}
                                //     onChange={(e) => {this.setState({studentId:e.value})
                                //     this.getTermBasedData()

                                // }}
                                onChange={this.onStudentChange}
                                placeholder={
                                    <div>
                                        <span className="">Select Student</span>
                                    </div>
                                }
                            />
                        </div>
                    </div> */}
                </div>

                <DataTable
                    ref={(el) => (this.dt = el)}
                    value={this.state.studentInfo}
                    dataKey="id"
                    paginator
                    // lazy
                    responsiveLayout="scroll"
                    className="dataTableValuesText"
                    showGridlines
                    selectionMode={'checkbox'}
                    columnResizeMode="expand"
                    resizableColumns
                    // selection={this.state.selectedProducts}
                    // onSelectionChange={(e) => this.setState((prevState)=>({selectedProducts:[...prevState.selectedProducts,e.value]}))}
                    onPage={this.onPage}
                    first={this.state.lazyParams.first}
                    last={this.state.totalRecords}
                    rows={this.state.lazyParams.rows}
                    totalRecords={this.state.totalRecords}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    globalFilter={this.state.globalFilter}

                    selection={this.state.selectedRows}
                    onSelectionChange={this.onSelectionChange}


                    // paginator
                    lazy={false} // Changed to false for front-end pagination
                    header={header}
                    rowHover
                    filters={this.state.filters} filterDisplay="menu" loading={this.state.loading}
                    globalFilterFields={[
                        'firstName',
                        'lastName',
                        'username',
                        'parentContactNo',
                        // 'enrollmentId',
                        // 'boardName',
                        // 'gradeName',
                        // 'sectionName',
                        // 'totalFee',
                        // 'concessionRaisedAmt'
                    ]}
                >
                    <Column
                        field="name"
                        // header="name"
                        filterField="name"
                        alignHeader={'center'}
                        sortable
                        bodyClassName="text-center"
                        header="Student Name"
                        body={(rowData, { rowIndex }) => {
                            return (
                                <div className="flex justify-content-center">
                                    {rowData?.firstName}
                                    {rowData?.lastName}
                                </div>
                            );
                        }}
                    />

                    <Column
                        field="enrollmentId"
                        filterField="enrollmentId"
                        sortable
                        bodyClassName="text-center"
                        header="Enrollment No"
                        alignHeader={'center'}
                        body={(rowData) => rowData.username ? rowData.username.slice(3) : ''} />

                    <Column sortable bodyClassName="text-center" header="Board" alignHeader={'center'} body={(rowData) => {
                        return (
                            <div className="flex justify-content-center">
                                {rowData?.boardName}
                            </div>
                        )
                    }} />
                    <Column sortable bodyClassName="text-center" header="Grade-Section" alignHeader={'center'} body={(rowData) => {
                        return (
                            <div className="flex justify-content-center">
                                {rowData?.gradeName} - {rowData?.sectionName}
                            </div>
                        )
                    }} />
                    <Column
                        filterField="totalFee" field="totalFee" sortable bodyClassName="text-center" header="Fee Paid" alignHeader={'center'} />
                    <Column
                        filterField="refundRaisedAmt" field="refundRaisedAmt" sortable bodyClassName="text-center" header="Refund" alignHeader={'center'} />
                    <Column
                        alignHeader={'center'}
                        sortable
                        bodyClassName="text-center"
                        header="Details"
                        body={(rowData, { rowIndex }) => {
                            return <Button id={rowData?._id} onClick={() => this.onHandleViewFeeConcessions(rowData)} icon="pi pi-ellipsis-v" className=" p-button-text p-button-secondary ma-ml10" />;
                        }}
                    ></Column>
                </DataTable>

                <Dialog
                    isopen={this.state.viewRefundDetails}
                    visible={this.state.viewRefundDetails}
                    className="w-11"
                    draggable={false}
                    onHide={this.onHandleRefundClose}
                    closable={true}
                    header={() => {
                        console.log(this.state);
                        return (
                            <div className="mt-2 mb-4">
                                <h3 className="formhead text-center ">Approve Raised Refunds</h3>
                            </div>
                        );
                    }}
                    footer={() => <div className="flex justify-content-center  align-items-center mb-4"></div>}
                >
                    <>
                        <div className="grid m-2">
                            <div className="col-4 ">
                                <label className="ma-label-s2 font-serif font-semibold text-900 text-lg">Student Name</label>
                                <div className="mt-2">
                                    <ClassetInputText
                                        id="studentName"
                                        // icon={<MailIcon />}
                                        className=""
                                        height="48px"
                                        width="368px"
                                        value={`${this.state?.raisedFeeRefundData?.firstName} ${this.state?.raisedFeeRefundData?.lastName}`}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-4 ">
                                <label className="ma-label-s2 font-serif font-semibold text-900 text-lg">Enrollment No</label>
                                <div className="mt-2">
                                    <ClassetInputText id="enrollmentNo"
                                        // icon={<MailIcon />} 
                                        height="48px" width="368px" value={this.state?.raisedFeeRefundData?.username?.slice(3)} disabled={true} />

                                </div>
                            </div>
                            <div className="col-4">
                                <label className="ma-label-s2 font-serif font-semibold text-900 text-lg">Grade</label>
                                <div className="mt-2">
                                    <ClassetInputText id="grade"
                                        // icon={<MailIcon />} 
                                        height="48px" width="368px" value={this.state?.raisedFeeRefundData?.gradeName} disabled={true} />
                                </div>
                            </div>
                            <div className="col-4">
                                <label className="ma-label-s2 font-serif font-semibold text-900 text-lg">Section</label>
                                <div className="mt-2">
                                    <ClassetInputText id="section"
                                        // icon={<MailIcon />} 
                                        height="48px" width="368px" value={this.state?.raisedFeeRefundData?.sectionName} disabled={true} />
                                </div>
                            </div>
                            <div className="col-4">
                                <label className="ma-label-s2 font-serif font-semibold text-900 text-lg">Board</label>
                                <div className="mt-2">
                                    <ClassetInputText id="board"
                                        // icon={<MailIcon />} 
                                        height="48px" width="368px" value={this.state?.raisedFeeRefundData?.boardName} disabled={true} />
                                </div>
                            </div>
                        </div>

                        <DataTable
                            ref={(el) => (this.dt = el)}
                            value={this.state?.raisedFeeRefundData?.refundFeeTypesData?.filter(e => e?.isClosed == false || e?.isClosed == undefined)}
                            dataKey="id"
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            globalFilter={this.state.globalFilter}
                        >
                            <Column filterField="feeType" field="feeType" sortable bodyClassName="text-center" header="Fee Type" alignHeader={'center'} />
                            <Column filterField="amountPaid" field="amountPaid" sortable bodyClassName="text-center" header="Paid Fee" alignHeader={'center'} />
                            <Column
                                filterField="refundAmount"
                                field="termWisePercentageOrValue"
                                sortable
                                bodyClassName="text-center"
                                header="Refund Amount"
                                alignHeader={'center'}
                                body={(rowData, index) => {
                                    return <p>{rowData?.refundAmt || 0}</p>;
                                }}
                            />
                            <Column
                                filterField="totalDue"
                                field="totalDue"
                                sortable
                                bodyClassName="text-center"
                                header="Total Due"
                                alignHeader={'center'}
                                body={(rowData, index) => {
                                    const totalDue = Number(rowData?.totalDue || 0);
                                    const concession = Number(rowData?.concession || 0);
                                    const finalDue = totalDue - concession;
                                    return <p>{finalDue.toFixed(2)}</p>;
                                }}
                            />
                            <Column
                                style={{ width: '15rem', height: '6rem' }}
                                alignHeader={'center'}
                                sortable
                                headerClassName="text-color-secondary"
                                bodyClassName="text-center"
                                className=" "
                                header="Approve / Reject"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <>
                                            {rowData?.isRefundApproved == undefined && (
                                                <div className="flex justify-content-evenly">
                                                    <div className="cursor-pointer" onClick={() => this.onHandleFeeRefundApprove(rowData, true)}>
                                                        <GreenCheck />
                                                    </div>

                                                    <div className="cursor-pointer" onClick={() => this.onHandleFeeRefundApprove(rowData, false)}>
                                                        <CancelRed />
                                                    </div>
                                                </div>
                                            )}

                                            {rowData?.isRefundApproved == true && (
                                                <div className="cursor-pointer">
                                                    <Button className="approve-btn" style={{ backgroundColor: '#7CDD56' }}>
                                                        Approved
                                                    </Button>
                                                </div>
                                            )}
                                            {rowData?.isRefundApproved == false && (
                                                <div className="cursor-pointer">
                                                    <Button className="approve-btn" style={{ backgroundColor: '#BF0031' }}>
                                                        Rejected
                                                    </Button>
                                                </div>
                                            )}
                                        </>
                                    );
                                }}
                            ></Column>
                        </DataTable>

                        <div className=" mx-2 my-3">
                            <ClassetTextArea placeholder="Remarks" className="" width={'98%'} height={'150px'} value={this.state.remarks} onChange={(e) => this.setState({ remarks: e.target.value })} />
                        </div>
                        <div className="flex justify-content-center  align-items-center mt-4">
                            <Button label="Confirm" className="submitButtonn mr-4 button text-lg " onClick={this.onHandleApprovedRefunds} />
                            <Button className="cancelButtonn " onClick={() => this.onHandleRefundClose()}>
                                <p className="cancelButtonnText">Cancel</p>
                            </Button>
                        </div>
                    </>
                </Dialog>

                <Toast ref={(el) => (this.toast = el)} position="bottom-right" />
                {this.state.isLoading && <LoadingComponent />}
            </div>
        );
    }
}

export default withRouter(Authentication(FeeRefundApproval));
